export default "<ng-template [ngTemplateOutlet]=\"data.template\"></ng-template>\n"